import { render, staticRenderFns } from "./variation-modal-share.vue?vue&type=template&id=06de4b44&"
import script from "./variation-modal-share.vue?vue&type=script&lang=js&"
export * from "./variation-modal-share.vue?vue&type=script&lang=js&"
import style0 from "./variation-modal-share.vue?vue&type=style&index=0&id=06de4b44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports